import PartNumber from './part-number';

export default PartNumber;